import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ConfSmartServices from "./ConfSmart.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetConfSmart = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: true,
    });
    dispatch({
      type: actions.GET_CONF_SMART,
      payload: {
        confSmarts: [],
        confSmartsLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: false,
    });
  }
};

export const resetConfSmartEmpleados = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: true,
    });
    dispatch({
      type: actions.GET_CONF_SMART_EMPLEADOS,
      payload: {
        confSmartEmpleados: [],
        confSmartEmpleadosLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: false,
    });
  }
};

export const getConfSmart = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: true,
    });
    const resp = await ConfSmartServices.getConfSmart(filters);
    dispatch({
      type: actions.GET_CONF_SMART,
      payload: {
        confSmarts: resp.data.data || [],
        confSmartsLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: false,
    });
  }
};


export const getConfSmartEmpleados = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: true,
    });
    const resp = await ConfSmartServices.getConfSmartEmpleados(filters);
    dispatch({
      type: actions.GET_CONF_SMART_EMPLEADOS,
      payload: {
        confSmartEmpleados: resp.data.data || [],
        confSmartEmpleadosLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: false,
    });
  }
};

export const getConfSmartById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CONF_SMART_BY_ID,
      payload: true,
    });
    const resp = await ConfSmartServices.getConfSmartById(id);
    dispatch({
      type: actions.GET_CONF_SMART_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CONF_SMART_BY_ID,
      payload: false,
    });
  }
};

export const saveConfSmart = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_CONF_SMART,
      payload: true,
    });
    await ConfSmartServices.saveConfSmart(data);
   
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            }
            else if (ex.response.data && ex.response.data.error) {
              message = ex.response.data.error;
            }
            else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            
            message += ".\nAsegúrese de que los empleados seleccionados cumplan con lo siguiente:\n- Clasificación asignada \n- Descriptor completo \n- Estar activo \n- Jefe asignado \n- Correo electrónico registrado \n- Puesto asignado \n- Empresa asignada \n- Unidad Organizativa asignada";
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });

  } finally {
    dispatch({
      type: actions.SAVE_LOADING_CONF_SMART,
      payload: false,
    });
  }
};

export const editConfSmart = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_CONF_SMART,
      payload: true,
    });
    const resp = await ConfSmartServices.editConfSmart(id, data);
    const { confSmarts, confSmartsLength } = getState().confSmart;
    confSmarts[index] = resp.data;
    dispatch({
      type: actions.GET_CONF_SMART,
      payload: {
        confSmarts: confSmarts,
        confSmartsLength: confSmartsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_CONF_SMART,
      payload: false,
    });
  }
};

export const deleteConfSmart = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: true,
    });
    await ConfSmartServices.deleteConfSmart(id);
    const { confSmarts, confSmartsLength } = getState().confSmart;
    confSmarts.splice(index, 1);
    dispatch({
      type: actions.GET_CONF_SMART,
      payload: {
        confSmarts: confSmarts,
        confSmartsLength: confSmartsLength - 1,
      },
    });
    dispatch({
      type: actions.CONF_SMART_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CONF_SMART,
      payload: false,
    });
  }
};
